import SetupWidget from './SetupWidget';

export default SetupWidget;
